import { render, staticRenderFns } from "./researchMode.vue?vue&type=template&id=69644d7c&scoped=true&"
import script from "./researchMode.vue?vue&type=script&lang=js&"
export * from "./researchMode.vue?vue&type=script&lang=js&"
import style0 from "./researchMode.vue?vue&type=style&index=0&id=69644d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69644d7c",
  null
  
)

export default component.exports